import { Icon } from "@progress/kendo-react-common";
import { GridCellProps } from "@progress/kendo-react-grid";
import { QuoteStatus } from "../../types/quoteStatus";
import { CustomGridCell } from "../grid";

export const StatusCell = (props: GridCellProps) => {
  const { field, dataItem } = props;
  const status: string = dataItem[field || ""];
  const isActionable = dataItem.configurationEnabled;
  const title = status === "Open" && !isActionable ? "Deactivated" : status;

  return (
    <CustomGridCell {...props}>
      <span title={title}>
        {title === QuoteStatus.Approved && <Icon name="check" themeColor="primary" />}
        {title === QuoteStatus.Rejected && <Icon name="x-circle" themeColor="error" />}
        {title === QuoteStatus.Pending && <Icon name="clock" themeColor="warning" />}
        {title === "Deactivated" && <Icon name="cancel" themeColor="error" />}
      </span>
    </CustomGridCell>
  );
};
